import React, { useState } from 'react';
import './HomeQuerys.css';

const faqs = [
  {
    question: 'Por que vender minha cota de consórcio cancelada?',
    answer: 'Vender sua cota de consórcio cancelada pode ser uma ótima opção para recuperar parte do investimento feito sem ter que esperar até o final do grupo. Isso é especialmente útil se você precisa de dinheiro imediato, além de obter um retorno financeiro mais rápido e evitar a desvalorização do valor investido no pagamento das parcelas mensais.'
  },
  {
    question: 'Como funciona o processo de venda de cota cancelada?',
    answer: 'De forma simples e transparente avaliamos a sua cota cancelada pelo melhor valor de mercado, sendo que essa avaliação (proposta) pode ser alcançada também pelo simples uso da calculadora disponível no nosso site. Em seguida, com a aceitação da proposta pelo consorciado, a negociação é celebrada mediante instrumento de cessão de crédito (parcelas pagas) e PAGAMENTO IMEDIATO do valor da proposta.'
  },
  {
    question: 'Quais as outras vantagens de vender meu consórcio cancelado?',
    answer: 'Além de antecipar os valores pagos ao fundo comum da sua cota de consórcio cancelada, a forma de cálculo que utilizamos não leva em conta a multa cobrada pelas administradoras por supostos prejuízos causados pelo cancelamento da cota, e evita a cobrança de taxa de permanência aplicada para o caso de demora no recebimento após o encerramento do grupo.'
  },
  {
    question: 'Qualquer cota de consórcio cancelada pode ser vendida?',
    answer: 'Adquirimos cotas canceladas cujo valor recebível seja igual ou superior a R$ 5.000,00 (cinco mil reais), ainda que a proposta não seja emitida pela calculadora disponível no nosso site. O valor recebível perante a administradora, no encerramento do grupo, pode ser apurado pela simples multiplicação do percentual amortizado (pago) ao fundo comum da cota pelo valor do bem atual e considerado a data de encerramento do grupo.'
  },
  {
    question: 'A venda de cota cancelada precisa de autorização da administradora do grupo de consórcio?',
    answer: 'Por tratar-se de cota cancelada, portanto, de consorciado excluído do grupo de consórcio, a venda da cota (cessão de crédito) não depende da anuência da administradora, pois, nesse caso nenhuma obrigação é transferida, mas apenas o direito de recebimento do crédito em relação ao fundo comum das parcelas pagas, no momento oportuno.'
  },
  {
    question: 'O consorciado excluído do grupo precisa comunicar a administradora sobre a venda da cota cancelada?',
    answer: 'Feita a venda da cota de consórcio cancelada, nos cabe notificar a administradora para dar ciência da cessão de crédito – negociação realizada entre as partes.'
  },
];

function HomeQuerys() {
  const [openItems, setOpenItems] = useState(faqs.map(() => false));

  const toggle = (index) => {
    setOpenItems(prev => prev.map((open, i) => i === index ? !open : open));
  };

  return (
    <div className='justify-center mx-auto my-auto w-full max-w-3xl px-4'>
      <div className='text-center'>
        <span style={{ color: '#f5be88' }}>Dúvidas</span>
      </div>
      <div className='text-center'>
        <span className='text-3xl font-extrabold font-raleway'>Perguntas frequentes</span>
      </div>
      <div className='mt-4'>
        {faqs.map((faq, index) => (
          <div key={index} className="rounded-md overflow-hidden mb-4">
            <button
              type="button"
              className="flex justify-between items-center px-4 py-2 bg-gray-100 w-full text-left focus:outline-none"
              onClick={() => toggle(index)}
            >
              <span className="font-bold text-xl">{faq.question}</span>
              <img
                src="chevron_down.png"
                alt=""
                style={{
                  transform: openItems[index] ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease',
                  flexShrink: 0,
                }}
              />
            </button>
            {openItems[index] && (
              <div className="px-4 py-2 pt-1 bg-gray-100">
                <p className="text-base">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomeQuerys;
